export enum BillStatusEnum
{
    Active,
    Printed,
    Paid
}
export enum BillStatuses{
    Active = 'Active',
    Printed = 'Printed',
    Paid = 'Paid'
}